<script setup lang="ts">
const props = defineProps<{
  action: () => void;
}>();
</script>
<template>
  <div class="w-100">
    <v-btn
      style="color: white; font-weight: bold; background-color: #3388DC;"
      class="mb-2"
      @click="props.action"
    >
      <slot></slot>
    </v-btn>
  </div>
</template>